import {generateKeyFromName} from "./index.js";


export type IndustryUnits = {
	  unit1: string,
	  unit2: string,
	  unit3: string,
};


export class Industry {
	  constructor(industryKey: string, industryName: string, industryUnits: IndustryUnits) {
			 this.industryKey = industryKey;
			 this.industryName = industryName;
			 this.industryUnits = industryUnits;
	  }
	  
	  
	  static fromObject(obj) {
			 return new Industry(obj.industryKey, obj.industryName, obj.industryUnits);
	  }
}


export class Product {
	  constructor(productName: string, productVariantName: string) {
			 this.productName = productName;
			 this.productVariantName = productVariantName;
	  }
	  
	  
	  static fromObject(obj) {
			 return new Product(obj.productName, obj.productVariantName);
	  }
	  
	  
	  getKey() {
			 return generateKeyFromName(this.productName + this.productVariantName);
	  }
}


export class Business {
	  constructor(businessName: string) {
			 this.businessName = businessName;
	  }
	  
	  
	  static fromObject(obj) {
			 return new Business(obj.businessName);
	  }
	  
	  
	  getKey() {
			 return generateKeyFromName(this.businessName);
	  }
}


export class Pricing {
	  constructor(productKey: string, businessKey: string, productName: string, productVariantName: string, businessName: string, price: number, quantity: number, unit: string) {
			 this.productKey = productKey;
			 this.businessKey = businessKey;
			 this.productName = productName;
			 this.productVariantName = productVariantName;
			 this.businessName = businessName;
			 this.price = price;
			 this.quantity = quantity;
			 this.unit = unit;
	  }
	  
	  
	  static fromObject(obj) {
			 return new Pricing(obj.productKey, obj.businessKey, obj.productName, obj.productVariantName, obj.businessName, obj.price, obj.quantity, obj.unit);
	  }
	  
	  
	  getKey() {
			 return generateKeyFromName(this.productKey + this.businessKey);
	  }
}


export class Milestone {
	  constructor(milestoneKey: string, milestoneTitle: string, milestoneDetails: string, milestoneMillis: number) {
			 this.milestoneKey = milestoneKey;
			 this.milestoneTitle = milestoneTitle;
			 this.milestoneDetails = milestoneDetails;
			 this.milestoneMillis = milestoneMillis;
			 this.isAchieved = false;
			 this.achievedOn = null;
	  }
	  
	  
	  static fromObject(obj) {
			 const milestone = new Milestone(obj.milestoneKey, obj.milestoneTitle, obj.milestoneDetails, obj.milestoneMillis);
			 milestone.isAchieved = obj.isAchieved || false;
			 milestone.achievedOn = obj.achievedOn || null;
			 return milestone;
	  }
	  
	  
	  static millisPath() {
			 return "milestoneMillis";
	  }
	  
	  
	  static isAchievedPath() {
			 return "isAchieved";
	  }
	  
	  
	  static achievedOnPath() {
			 return "achievedOn";
	  }
}


export class Expense {
	  constructor(expenseKey: string, expenseMillis: number, expenseDetails: string, expenseSerialNumber: number, expenseCost: number) {
			 this.expenseKey = expenseKey;
			 this.expenseMillis = expenseMillis;
			 this.expenseDetails = expenseDetails;
			 this.expenseSerialNumber = expenseSerialNumber;
			 this.expenseCost = expenseCost;
	  }
	  
	  
	  static fromObject(obj) {
			 return new Expense(obj.expenseKey, obj.expenseMillis, obj.expenseDetails, obj.expenseSerialNumber, obj.expenseCost);
	  }
	  
	  
	  static millisPath() {
			 return "expenseMillis";
	  }
}
